import { FC } from "react";
import { useI18n } from "../../hooks/useTranslations";
import AccountButton from "../AccountButton";
import Hamburger from "./Hamburger";
import styles from "./Header.module.css";
import LanguageSelector from "./LanguageSelector";
import NotificationBell from "./NotificationBell";

type HeaderProps = {
  title: string;
};

const Header: FC<HeaderProps> = ({ title }: HeaderProps) => {
  const i18n = useI18n();
  return (
    <div className={styles.header}>
      <Hamburger />
      <div className={styles.title}>{title}</div>

      {import.meta.env.MODE === "staging" && (
        <div className={styles.env}>
          <span className={styles.mode}>{i18n.t.common.testEnvironment}</span>
        </div>
      )}
      <div className={styles.user}>
        <NotificationBell />
        <LanguageSelector />
        <AccountButton />
      </div>
    </div>
  );
};

export default Header;
